// extracted by mini-css-extract-plugin
export default {"content":"Subtitle_content__EZbHs"};